import { useEffect, useState, useMemo } from "react";
import { COST_UNIT, MEGA_POWER_UNIT, VOLUME_UNIT } from "../../../Units";
import {
  PrimaryColor,
  SecondaryColor,
  buildHttpReq,
  buildUrl,
} from "../../../common";
import { tab } from "./interface/tabs";
import "./styles.css";
import { ExchangeLegend } from "./interface/legends";
import {
  BuyerSellerData,
  ComparisonData,
  ExchangeColors,
  FormatExchangeData,
  RealTimeChartData,
  ReformattedData,
  getDaysInMonthFromString,
  reformatData,
} from "./FormatData";
import {
  BuyerSellerChart,
  ExchangeChart,
  ExchangeReChart,
  renderCustomizedLabel,
  UtilizationTrendChart,
} from "./Chart";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { useDispatch, useSelector } from "react-redux";
import {
  AddBuyerSellerFilter,
  BuyerSellerFilter,
  BuyerSellerFilters,
  setBuyerSellerData,
  setTrendData,
  subfilter,
} from "../../../store/state/BuyerSellerState";
import { RootState } from "../../../store/store";
import {
  fetchExchangeData,
  setComparisonRawData,
  setExchangePage,
  setSelectedExchange,
  setSelectedProduct,
} from "../../../store/state/Exchange/ExchangeState";
import Select from "react-select";
import { ReactComponent as Cross } from "../../../icons/cross.svg";
import { LoadingItem } from "../../../components/Loading";
import {
  COLORS,
  ReBarChart,
  ReLineChart,
} from "../../../components/recharts/ReCharts";
import swal from "sweetalert";
import { FilterExchangeData } from "../../../store/state/Exchange/function";
import Popup from "./components/Popup";
import { EntityPage } from "./Entity";
import {
  BrushStart,
  ChartType,
  LegendKey,
  getColorList,
} from "../../../models/chart_model";
import {
  fetchExchangeComparisonData,
  fetchExchangeSlotData,
} from "../../../Rest_api/RestApi";
import {
  buildBaseUrl,
  buildFormDataRequest,
  buildHeaderTokens,
} from "../../../Rest_api/Network_utility";
import { renderHourTick } from "../../../components/recharts/components";
import { FilterTab, getResultFilterOptions } from "../../../components/Filters";
import Dropdown, { CalendarDropdown } from "../../../components/Dropdown";
import { LegendComponent } from "../../../components/recharts/ReMixCharts";
import { ReMixChart } from "../../../components/recharts/OldReMixCharts";
export function Exchange3() {
  const now = new Date();
  const maxDate = new Date(now.getFullYear(), now.getMonth() + 1, 0); // Last day of current month
  let comparisonRawData: {
    date_range: { start_date: string; end_date: string };
    data: any;
  }[] = [];
  const [ccomparisonLoading, setComparisonLoading] = useState(true);
  const [startDate, setStartDate] = useState(
    new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)
  );
  const [endDate, setEndDate] = useState(
    new Date(new Date().getTime() - 0 * 24 * 60 * 60 * 1000)
  );

  const [entityStartDate, setEntityStartDate] = useState(
    new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)
  );
  const [entityEndDate, setEntityEndDate] = useState(
    new Date(new Date().getTime() - 0 * 24 * 60 * 60 * 1000)
  );
  const [entityMaxDate, setEntityMaxDate] = useState(new Date());
  const [RealTimeChartData, setRealTimeChartData] = useState<
    RealTimeChartData[]
  >([]);
  const [popUpVisible, setPopUpVisible] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState("");
  const [popupData, setPopupData] = useState<{
    buyer: any[];
    seller: any[];
  }>({
    buyer: [],
    seller: [],
  });
  const tabs: tab[] = [
    {
      name: "By Exchange",
      active: true,
    },
    {
      name: "By Product",
      active: false,
    },
    {
      name: "Realtime",
      active: false,
    },
    {
      name: "Buyers & Sellers",
      active: false,
    },
    {
      name: "Trend Analysis",
      active: false,
    },
    // {
    //   name: "Entity Analysis",
    //   active: true,
    // },
  ];

  const EXCHANGES = ["IEX", "PXIL", "HPX"];

  const PRODUCTS = ["DAM", "GDAM", "HPDAM", "RTM"];

  const BuyerSellerTab: string[] = ["Top Players", "Trends"];

  const getUpdatedFilterSelection = (
    currentFilters: subfilter[],
    toggledFilter: subfilter,
    allFilters: subfilter[]
  ): subfilter[] => {
    const isAlreadySelected = currentFilters.some(
      (filter) => filter.id === toggledFilter.id
    );

    if (isAlreadySelected && currentFilters.length === allFilters.length) {
      return [toggledFilter];
    }

    if (!isAlreadySelected) {
      return [...currentFilters, toggledFilter];
    }

    if (currentFilters.length === 1) {
      return allFilters;
    }

    return currentFilters.filter((filter) => filter.id !== toggledFilter.id);
  };

  const [trendBuyer, setTrendBuyer] = useState<string[]>([
    "UPPCL",
    "RAJASTHAN",
    "ODISHA",
    "WBSETCL",
  ]);
  // let trendSeller: string[] = ["TSTRANSCO", "PUNJAB", "JK&LADAKH", "TNEB"];
  const [trendSeller, setTrendSeller] = useState<string[]>([
    "TSTRANSCO",
    "PUNJAB",
    "JK&LADAKH",
    "TNEB",
  ]);
  const Years = [2023, 2024, 2025];
  const Months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const [selectedEntity, setSelectedEntity] = useState<
    {
      label: string;
      value: number;
    }[]
  >([
    {
      label: "RAJASTHAN",
      value: 3034,
    },
  ]);
  let selectedComparisonDate: Date[] = [];

  // Memoize dateOptions for efficiency
  const dateOptions = useMemo(() => {
    return Years.flatMap((year, i1) => {
      return Months.map((month, i2) => {
        const optionDate = new Date(year, Months.indexOf(month), 1);
        // Only include months up to and including maxDate's month and year
        if (
          optionDate.getFullYear() < maxDate.getFullYear() ||
          (optionDate.getFullYear() === maxDate.getFullYear() &&
            optionDate.getMonth() <= maxDate.getMonth())
        ) {
          return {
            id: i1 + i2,
            value: optionDate,
            label: `${month} ${year}`,
            color: getColorList(Years.length * Months.length)[i1 + i2],
          };
        }
        return undefined;
      });
    })
      .reverse()
      .filter((option) => option !== undefined) as {
      value: Date;
      label: string;
      color: string;
    }[];
  }, [Years, Months, maxDate]);

  // Memoize exchangeLegends for efficiency
  const exchangeLegends = useMemo(
    () => [
      {
        name: `Price (${COST_UNIT})`,
        id: "price",
        color: PrimaryColor,
        active: true,
      },
      {
        name: `Sell Bids ${MEGA_POWER_UNIT}`,
        id: "sellBids",
        color: SecondaryColor,
        active: true,
      },
      {
        name: `Purchase Bids ${MEGA_POWER_UNIT}`,
        id: "purchaseBids",
        color: "#333333",
        active: true,
      },
      {
        name: "MCV",
        id: "mcv",
        color: "#9F9F9F",
        active: true,
      },
    ],
    []
  );

  const unitTabs = [
    {
      dataKey: "wt_mcp_rs_mwh",
      name: "MCP",
      unit: COST_UNIT,
    },

    {
      dataKey: "mcv_mw",
      name: "MCV",
      unit: MEGA_POWER_UNIT,
    },

    {
      dataKey: "sell_bid_mw",
      unit: MEGA_POWER_UNIT,
      name: "Sell Bids",
    },
    {
      dataKey: "purchase_bid_mw",
      name: "Purchase Bids",
      unit: MEGA_POWER_UNIT,
    },
    {
      name: "Weighted MCP",
      unit: COST_UNIT,
    },
  ];

  const [buyerSellerPage, setBuyerSellerPage] = useState(0);

  const searchStyle = {
    valueContainer: (base: any) => ({
      ...base,
      maxHeight: 40,
      overflowY: "auto",
    }),
    multiValue: (base: any, state: { data: { isFixed: any } }) => {
      return state.data.isFixed ? { ...base, backgroundColor: "gray" } : base;
    },
    multiValueLabel: (base: any, state: { data: { isFixed: any } }) => {
      return state.data.isFixed
        ? { ...base, fontWeight: "bold", color: "white", paddingRight: 6 }
        : base;
    },
    multiValueRemove: (
      base: any,
      state: {
        data: {
          value: any;
          isFixed: any;
        };
      }
    ) => {
      return state.data.isFixed ? { ...base, display: "none" } : base;
    },
  };
  const [selectedComparisonExchange, setSelectedComparisonExchange] =
    useState(0);

  const [selectedOptions, setSelectedOptions] = useState<
    {
      value: Date;
      label: string;
    }[]
  >([]);
  const [realTimechartIndex, setRealtimeChartIndex] = useState<number>(1);

  const [activeUnitTab, setActiveUnitTab] = useState(0);

  const [chartData, setChartData] = useState<{
    data: ReformattedData;
    legends: LegendKey[];
  }>({
    data: {
      iex: {
        dam: [],
        gdam: [],
        rtm: [],
        hpdam: [],
      },
      pxil: {
        dam: [],
        gdam: [],
        rtm: [],
        hpdam: [],
      },
      hpx: {
        dam: [],
        gdam: [],
        rtm: [],
        hpdam: [],
      },
    },
    legends: [],
  });

  const state = useSelector((state: RootState) => state.exchange);

  const dispatch = useDispatch();
  const BuyerSellerState = useSelector((state: RootState) => state.buyerSeller);

  useEffect(() => {
    getExchangeData({ start_date: startDate, end_date: endDate });
    fetchRealTimeData();
    // Fetch buyer vs seller data when component mounts
    fetchBuyerVsSellerData({
      start_date: entityStartDate,
      end_date: entityEndDate,
      exchange: BuyerSellerState.BuyerSeller.filters[0],
      product: BuyerSellerState.BuyerSeller.filters[1],
      region: BuyerSellerState.BuyerSeller.filters[2],
    });

    // Initialize selected options with the first date option
    setSelectedOptions(dateOptions.slice(0, 1));

    // Fetch comparison data for the selected date
    getComparisonExchangeData({
      dates: dateOptions.slice(0, 1).map((e) => e.value),
    });

    // Fetch utility trend data for buyers and sellers
    fetchUtilityTrendData({
      buyers: trendBuyer,
      sellers: trendSeller,
      startDate: entityStartDate,
      endDate: entityStartDate, // Note: Using same date for start and end
      exchange: BuyerSellerState.BuyerSeller.filters[0],
      product: BuyerSellerState.BuyerSeller.filters[1],
      region: BuyerSellerState.BuyerSeller.filters[2],
    });
  }, []); // Empty dependency array means this runs once on component mount

  // Loading state flags for different data sections
  const [exchangeLoading, setExchangeLoading] = useState(false);
  const [realTimeLoading, setRealTimeLoading] = useState(true);
  const [buyerSellerLoading, setBuyerSellerLoading] = useState(true);
  const [utilityTrendLoading, setUtilityTrendLoading] = useState(true);

  // Handler for chart bar click events - fetches detailed slot data
  const handleBarClick = (data: any) => {
    fetchSlotData({
      exchange: data.payload.exchange__name,
      product: data.payload.product__name,
      date: data.payload.date,
      slot: data.payload.time_slot,
    });
  };

  // Stable no-op for setShownLegends
  const noopSetShownLegends = () => {};

  return (
    <div>
      {/* Header */}
      <div className="header">
        <div>
          <h1>Exchange</h1>
        </div>
        <div className="header-side-area">
          {state.page === 2 && <div></div>}

          {state.page === 4 && (
            <div className="header-side-area">
              <Select
                placeholder="Select Months..."
                value={selectedOptions.map((option) => ({
                  ...option,
                  isFixed: false,
                }))}
                isMulti={true}
                onChange={(value) => {
                  setSelectedOptions(value as any);
                  getComparisonExchangeData({
                    dates: value.map((e) => e.value),
                  });
                }}
                styles={searchStyle}
                options={
                  /* date options that are not in the selected options */
                  dateOptions
                    .filter(
                      (option) =>
                        !selectedOptions
                          .map((e) => e.label)
                          .includes(option.label)
                    )
                    .map((option) => ({ ...option, isFixed: false }))
                }
              />
            </div>
          )}
          {state.page === 2 && !realTimeLoading && (
            <CalendarDropdown
              options={RealTimeChartData.map((data) =>
                data.title.replaceAll("-", "/")
              )}
              selected={realTimechartIndex}
              onSelect={(option, index) => {
                setRealtimeChartIndex(index);
              }}
            />
          )}
          {state.page == 3 && (
            <FilterTab
              options={BuyerSellerTab}
              selected={[BuyerSellerTab[buyerSellerPage]]}
              onClick={(option, index) => {
                setBuyerSellerPage(index);
              }}
            />
          )}
          {getActivateFilter(true) && (
            <div className="date-selection">
              <input
                type="date"
                className="date-input"
                max={endDate
                  .toLocaleDateString("en-GB")
                  .split("/")
                  .reverse()
                  .join("-")}
                value={startDate
                  .toLocaleDateString("en-GB")
                  .split("/")
                  .reverse()
                  .join("-")}
                onChange={(e) => {
                  setStartDate(new Date(e.target.value));
                  getExchangeData({
                    start_date: new Date(e.target.value),
                    end_date: endDate,
                  });
                }}
              />
              to
              <input
                type="date"
                className="date-input"
                max={maxDate
                  .toLocaleDateString("en-GB")
                  .split("/")
                  .reverse()
                  .join("-")}
                min={startDate
                  .toLocaleDateString("en-GB")
                  .split("/")
                  .reverse()
                  .join("-")}
                value={endDate
                  .toLocaleDateString("en-GB")
                  .split("/")
                  .reverse()
                  .join("-")}
                onChange={(e) => {
                  setEndDate(new Date(e.target.value));
                  getExchangeData({
                    start_date: startDate,
                    end_date: new Date(e.target.value),
                  });
                }}
              />
            </div>
          )}

          {(state.page === 3 || state.page === 5) && (
            <div className="date-selection">
              <input
                type="date"
                className="date-input"
                max={entityEndDate
                  .toLocaleDateString("en-GB")
                  .split("/")
                  .reverse()
                  .join("-")}
                value={entityStartDate
                  .toLocaleDateString("en-GB")
                  .split("/")
                  .reverse()
                  .join("-")}
                onChange={(e) => {
                  setEntityStartDate(new Date(e.target.value));
                  fetchBuyerVsSellerData({
                    start_date: new Date(e.target.value),
                    end_date: entityEndDate,
                    product: BuyerSellerState.BuyerSeller.filters[1],
                    exchange: BuyerSellerState.BuyerSeller.filters[0],
                    region: BuyerSellerState.BuyerSeller.filters[2],
                  });
                  fetchUtilityTrendData({
                    buyers: trendBuyer,
                    sellers: trendSeller,
                    startDate: new Date(e.target.value),
                    endDate: entityEndDate,
                    exchange: BuyerSellerState.BuyerSeller.filters[0],
                    product: BuyerSellerState.BuyerSeller.filters[1],

                    region: BuyerSellerState.BuyerSeller.filters[2],
                  });
                }}
              />
              to
              <input
                type="date"
                className="date-input"
                max={entityMaxDate
                  .toLocaleDateString("en-GB")
                  .split("/")
                  .reverse()
                  .join("-")}
                value={entityEndDate
                  .toLocaleDateString("en-GB")
                  .split("/")
                  .reverse()
                  .join("-")}
                onChange={(e) => {
                  setEntityEndDate(new Date(e.target.value));
                  fetchBuyerVsSellerData({
                    start_date: entityStartDate,
                    end_date: new Date(e.target.value),
                    product: BuyerSellerState.BuyerSeller.filters[1],
                    exchange: BuyerSellerState.BuyerSeller.filters[0],
                    region: BuyerSellerState.BuyerSeller.filters[2],
                  });
                  fetchUtilityTrendData({
                    buyers: trendBuyer,
                    sellers: trendSeller,
                    startDate: entityStartDate,
                    endDate: new Date(e.target.value),
                    exchange: BuyerSellerState.BuyerSeller.filters[0],
                    product: BuyerSellerState.BuyerSeller.filters[1],

                    region: BuyerSellerState.BuyerSeller.filters[2],
                  });
                }}
              />
            </div>
          )}
        </div>
      </div>
      {/* Content */}
      {/* Removing Padding for the Market Editing Page */}
      {popUpVisible && (
        <Popup
          title={popUpTitle}
          isVisible={state.page == 1 || state.page == 0}
          onClose={() => {
            setPopUpVisible(false);
          }}
        >
          <div className="popup-buyerseller-container">
            <div
              style={{
                height: `${popupData.buyer.length * 8}vh`,
              }}
              className="popup-buyerseller-chart text-center"
            >
              <h2>Buyers</h2>
              <BuyerSellerChart data={popupData.buyer} showLegend={true} />
            </div>

            <div
              style={{
                height: `${popupData.seller.length * 8}vh`,
              }}
              className="popup-buyerseller-chart text-center"
            >
              <h2>Sellers</h2>
              <BuyerSellerChart data={popupData.seller} showLegend={true} />
            </div>
          </div>
        </Popup>
      )}
      <div
        className="loading-container"
        style={{ display: getLoading() ? "flex" : "none" }}
      >
        <LoadingItem />
      </div>
      <div
        className={"content2-padding-body"}
        style={{
          paddingTop: "10px",
        }}
      >
        {/* Filters */}
        {state.page !== 5 && (
          <div className="filters">
            <div className="legend-exchangeSelection container-radius">
              <div className="exchange-selection">
                {state.page === 0 && (
                  <FilterTab
                    options={EXCHANGES}
                    isRounded={true}
                    selected={[EXCHANGES[state.Exchange.selectedExchange]]}
                    isSecondary={true}
                    onClick={(option, index) => {
                      dispatch(setSelectedExchange(index));
                    }}
                  />
                )}
                {state.page === 1 && (
                  <FilterTab
                    options={PRODUCTS}
                    selected={[PRODUCTS[state.Exchange.selectedProduct]]}
                    isSecondary={false}
                    onClick={(option, index) => {
                      dispatch(setSelectedProduct(index));
                    }}
                  />
                )}

                {state.page === 3 && (
                  <div className="flex justify-between space-x-6">
                    <FilterTab
                      options={BuyerSellerFilters[0].filters.map(
                        (filter) => filter.name
                      )}
                      selected={BuyerSellerState.BuyerSeller.filters[0].filters.map(
                        (filter) => filter.name
                      )}
                      isRounded={true}
                      isSecondary={true}
                      onClick={(option, index) => {
                        const clickedFilter = BuyerSellerFilters[0].filters[index];
                        dispatch(
                          AddBuyerSellerFilter({
                            index: 0,
                            filter: clickedFilter,
                          })
                        );
                        fetchBuyerVsSellerData({
                          start_date: entityStartDate,
                          end_date: entityEndDate,
                          exchange: {
                            ...BuyerSellerState.BuyerSeller.filters[0],
                            filters: getUpdatedFilterSelection(
                              BuyerSellerState.BuyerSeller.filters[0].filters,
                              clickedFilter,
                              BuyerSellerFilters[0].filters
                            ),
                          },
                          product: BuyerSellerState.BuyerSeller.filters[1],
                          region: BuyerSellerState.BuyerSeller.filters[2],
                        });
                      }}
                    />

                    <FilterTab
                      options={BuyerSellerFilters[1].filters.map(
                        (filter) => filter.name
                      )}
                      selected={BuyerSellerState.BuyerSeller.filters[1].filters.map(
                        (filter) => filter.name
                      )}
                      onClick={(option, index) => {
                        const clickedFilter = BuyerSellerFilters[1].filters[index];
                        dispatch(
                          AddBuyerSellerFilter({
                            index: 1,
                            filter: clickedFilter,
                          })
                        );
                        fetchBuyerVsSellerData({
                          start_date: entityStartDate,
                          end_date: entityEndDate,
                          exchange: BuyerSellerState.BuyerSeller.filters[0],
                          product: {
                            ...BuyerSellerState.BuyerSeller.filters[1],
                            filters: getUpdatedFilterSelection(
                              BuyerSellerState.BuyerSeller.filters[1].filters,
                              clickedFilter,
                              BuyerSellerFilters[1].filters
                            ),
                          },
                          region: BuyerSellerState.BuyerSeller.filters[2],
                        });
                      }}
                    />
                  </div>
                )}

                {state.page === 4 && (
                  <div className="flex space-x-8">
                    <FilterTab
                      options={EXCHANGES}
                      isRounded={true}
                      selected={[EXCHANGES[selectedComparisonExchange]]}
                      isSecondary={true}
                      onClick={(option, index) => {
                        setSelectedComparisonExchange(index);
                      }}
                    />
                    <Dropdown
                      options={unitTabs.map((tab) => tab.name)}
                      selected={activeUnitTab}
                      onSelect={(option, index) => {
                        setActiveUnitTab(index);
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="header-tab-selection">
                <FilterTab
                  onClick={(option, index) => {
                    dispatch(setExchangePage(index));
                  }}
                  options={tabs.map((tab) => tab.name)}
                  selected={[tabs[state.page].name]}
                />
              </div>
            </div>
          </div>
        )}
        {/* Chart Area */}
        {state.page === 0 ? (
          <div className="exchange-chart-area">
            {["DAM", "GDAM", "HPDAM", "RTM"].map((title, idx) => (
              <div className="exchange-byExchange-chart" key={title}>
                <ResponsiveContainer>
                  <ExchangeReChart
                    title={title}
                    syncId="byExchange"
                    onBarClick={handleBarClick}
                    data={FilterExchangeData(state.Exchange.data, {
                      exchangeIndex: state.Exchange.selectedExchange,
                      exchangeProductIndex: idx,
                    })}
                    shownLegnends={[]}
                    setShownLegends={noopSetShownLegends}
                    brushStart={BrushStart.Start}
                  />
                </ResponsiveContainer>
              </div>
            ))}
            {(() => {
              const productIndexes = [0, 1, 2, 3];
              const dataLengths = productIndexes.map(
                (prodIdx) =>
                  FilterExchangeData(state.Exchange.data, {
                    exchangeIndex: state.Exchange.selectedExchange,
                    exchangeProductIndex: prodIdx,
                  }).length
              );
              const maxIdx = dataLengths.reduce(
                (maxI, len, i, arr) => (len > arr[maxI] ? i : maxI),
                0
              );
              return (
                <div
                  className="m-4 w-full h-[5rem] brush-container"
                  style={{
                    marginRight: "20px",
                    overflow: "visible",
                  }}
                >
                  <ExchangeChart
                    shownLegnends={[]}
                    setShownLegends={noopSetShownLegends}
                    data={FilterExchangeData(state.Exchange.data, {
                      exchangeIndex: state.Exchange.selectedExchange,
                      exchangeProductIndex: maxIdx,
                    })}
                    title={["DAM", "GDAM", "HPDAM", "RTM"][maxIdx]}
                    syncId="byExchange"
                    height="20%"
                    width="100%"
                    showBrush={true}
                    brushStart={BrushStart.Start}
                    onlyBrush={true}
                  />
                </div>
              );
            })()}
          </div>
        ) : state.page == 1 ? (
          <div className="exchange-chart-area">
            {[
              { title: "IEX", idx: 0 },
              { title: "PXIL", idx: 1 },
              { title: "HPX", idx: 2 },
            ].map(({ title, idx }) => (
              <div className="exchange-byExchange-chart" key={title}>
                <ResponsiveContainer>
                  <ExchangeReChart
                    title={title}
                    syncId="byProduct"
                    onBarClick={handleBarClick}
                    data={FilterExchangeData(state.Exchange.data, {
                      exchangeIndex: idx, // Use idx (0,1,2) for exchange
                      exchangeProductIndex: state.Exchange.selectedProduct, // Use selectedProduct for product
                    })}
                    shownLegnends={[]}
                    setShownLegends={noopSetShownLegends}
                    brushStart={BrushStart.Start}
                  />
                </ResponsiveContainer>
              </div>
            ))}
            {(() => {
              const exchangeIndexes = [0, 1, 2];
              const dataLengths = exchangeIndexes.map(
                (exIdx) =>
                  FilterExchangeData(state.Exchange.data, {
                    exchangeIndex: exIdx, // Use exIdx for exchange
                    exchangeProductIndex: state.Exchange.selectedProduct, // Use selectedProduct for product
                  }).length
              );
              const maxIdx = dataLengths.reduce(
                (maxI, len, i, arr) => (len > arr[maxI] ? i : maxI),
                0
              );
              return (
                <div className="m-4 w-full h-[5rem] brush-container">
                  <ExchangeChart
                    shownLegnends={[]}
                    setShownLegends={noopSetShownLegends}
                    data={FilterExchangeData(state.Exchange.data, {
                      exchangeIndex: maxIdx, // Use maxIdx for exchange
                      exchangeProductIndex: state.Exchange.selectedProduct, // Use selectedProduct for product
                    })}
                    title={["IEX", "PXIL", "HPX"][maxIdx]} // Use exchange names, not product names
                    syncId="byProduct"
                    height="20%"
                    width="100%"
                    showBrush={true}
                    onlyBrush={true}
                    brushStart={BrushStart.Start}
                  />
                </div>
              );
            })()}
          </div>
        ) : state.page == 2 ? (
          /* Realtime Chart */

          <div className="onechart-container exchange-chart-area">
            <div className="flex justify-center gap-8"></div>
            <div className="realTime-chart">
              <div className="flex justify-center">
                <h1> Price (IEX) ({COST_UNIT}) </h1>
              </div>
              <ReLineChart
                xLabel="Time (Hrs)"
                isTimeSlot={true}
                data={
                  RealTimeChartData.length > 0
                    ? RealTimeChartData[realTimechartIndex!].data
                    : []
                }
                xTick={renderHourTick}
                unit={COST_UNIT}
                yAxisLabel={COST_UNIT}
                legends={
                  RealTimeChartData.length > 0
                    ? Object.keys(
                        RealTimeChartData[realTimechartIndex!].data[0]
                      ).map((item, index) => {
                        return {
                          dataKey: item,
                          name: item.replace("_rates", ""),
                          stroke:
                            COLORS[
                              index > COLORS.length - 1
                                ? index - COLORS.length
                                : index
                            ],
                        };
                      })
                    : []
                }
                xDataKey={"timeslot"}
              />
            </div>
          </div>
        ) : state.page == 3 ? (
          <div>
            <div>
              <div className="body-container">
                <div className="w-full h-full">
                  {buyerSellerPage === 0 ? (
                    <div className="exchange-topplayers-container">
                      <div className="exchange-topplayers-players-container">
                        <div className="exchange-topplayers-players-chartarea">
                          <h3>Buyers (MWh)</h3>
                          <div className="buyerSellerChart">
                            <div
                              className="exchange-topplayers-players"
                              style={{
                                height: `${
                                  BuyerSellerState?.BuyerSeller?.Data?.buyer
                                    ?.length * 8
                                }vh`,
                              }}
                            >
                              <BuyerSellerChart
                                data={
                                  BuyerSellerState?.BuyerSeller?.Data?.buyer
                                }
                                showLegend={false}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="exchange-topplayers-players-chartarea">
                          <h3>Sellers (MWh)</h3>
                          <div className="buyerSellerChart">
                            <div
                              className="exchange-topplayers-players"
                              style={{
                                height: `${
                                  BuyerSellerState?.BuyerSeller?.Data?.seller
                                    ?.length * 8
                                }vh`,
                              }}
                            >
                              <BuyerSellerChart
                                data={
                                  BuyerSellerState?.BuyerSeller?.Data?.seller
                                }
                                showLegend={false}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="exchange-topplayers-region-container">
                        <div className="exchange-topplayers-players-chartarea">
                          <h3 className="buyerseller-heading">
                            By Region (MWh)
                          </h3>
                          <div className="exchange-buyerseller-region-chart-area">
                            <BuyerSellerPieChart
                              data={
                                BuyerSellerState.BuyerSeller.Data.region_buyer
                              }
                            />
                          </div>
                        </div>
                        <div className="exchange-topplayers-players-chartarea">
                          <h3 className="buyerseller-heading">
                            By Region ({VOLUME_UNIT})
                          </h3>
                          <div className="exchange-buyerseller-region-chart-area">
                            <BuyerSellerPieChart
                              data={
                                BuyerSellerState.BuyerSeller.Data.region_seller
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="exchange-buyerseller-trends-container">
                      <div className="exchange-buyerseller-trends-chart-container">
                        <h3 className="buyerseller-heading">Buyer</h3>
                        <Select
                          classNames={{}}
                          placeholder="Select Buyers"
                          value={[]}
                          defaultValue={[]}
                          isMulti={true}
                          onChange={(e) => {
                            console.log(e);

                            if (
                              trendBuyer.filter((item) => e[0].value == item)
                                .length === 0
                            ) {
                              setTrendBuyer([
                                ...trendBuyer,
                                e.map((item) => item.value)[0],
                              ]);

                              fetchUtilityTrendData({
                                sellers: trendSeller,
                                buyers: [
                                  ...trendBuyer,
                                  e.map((item) => item.value)[0],
                                ],
                                startDate: startDate,
                                endDate: endDate,
                                exchange:
                                  BuyerSellerState.BuyerSeller.filters[0],
                                product:
                                  BuyerSellerState.BuyerSeller.filters[1],

                                region: BuyerSellerState.BuyerSeller.filters[2],
                              });
                            } else {
                              fetchUtilityTrendData({
                                sellers: trendSeller,
                                buyers: trendBuyer.filter(
                                  (item) =>
                                    item !== e.map((item) => item.value)[0]
                                ),
                                startDate: startDate,
                                endDate: endDate,
                                exchange:
                                  BuyerSellerState.BuyerSeller.filters[0],
                                product:
                                  BuyerSellerState.BuyerSeller.filters[1],

                                region: BuyerSellerState.BuyerSeller.filters[2],
                              });
                              setTrendBuyer(
                                trendBuyer.filter(
                                  (item) =>
                                    item !== e.map((item) => item.value)[0]
                                )
                              );
                            }
                          }}
                          className="trendFilter"
                          options={BuyerSellerState.Trend.filters.buyer_name
                            .filter((item) => !trendBuyer.includes(item))
                            .map((item) => {
                              return {
                                value: item,
                                label: item,
                                isFixed: false,
                              };
                            })}
                          styles={searchStyle}
                        />
                        <div className="buyerSeller-legends"></div>
                        <div className="trends-chart">
                          <UtilizationTrendChart
                            data={BuyerSellerState.Trend.data.buyer}
                            mcp={BuyerSellerState.Trend.data.mcp}
                            legends={trendBuyer.map((item) => {
                              return {
                                dataKey: item,
                                name: item,
                              };
                            })}
                          />
                        </div>
                        <div className="buyerSeller-legends">
                          {trendBuyer.map((item, index) => {
                            return (
                              <button
                                onClick={() => {
                                  setTrendBuyer(
                                    trendBuyer.filter((item2) => item2 !== item)
                                  );
                                  fetchUtilityTrendData({
                                    sellers: trendSeller,
                                    buyers: trendBuyer.filter(
                                      (item2) => item2 !== item
                                    ),
                                    startDate: startDate,
                                    endDate: endDate,
                                    exchange:
                                      BuyerSellerState.BuyerSeller.filters[0],
                                    product:
                                      BuyerSellerState.BuyerSeller.filters[1],

                                    region:
                                      BuyerSellerState.BuyerSeller.filters[2],
                                  });
                                }}
                                key={index}
                                className="flex justify-between"
                              >
                                <div className="buyerSeller-Legend bar-legend">
                                  <p>
                                    <div
                                      className="dot"
                                      style={{
                                        backgroundColor:
                                          COLORS[
                                            index > COLORS.length - 1
                                              ? index - COLORS.length
                                              : index
                                          ],
                                      }}
                                    ></div>
                                    {item}
                                    <Cross />
                                  </p>
                                </div>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                      <div className="exchange-buyerseller-trends-chart-container">
                        <h3 className="buyerseller-heading">Seller</h3>
                        <Select
                          classNames={{}}
                          placeholder="Select Sellers"
                          value={[]}
                          defaultValue={[]}
                          isMulti={true}
                          onChange={(e) => {
                            console.log(e);

                            if (
                              trendSeller.filter((item) => e[0].value == item)
                                .length === 0
                            ) {
                              setTrendSeller([
                                ...trendSeller,
                                e.map((item) => item.value)[0],
                              ]);

                              fetchUtilityTrendData({
                                buyers: trendBuyer,
                                sellers: [
                                  ...trendSeller,
                                  e.map((item) => item.value)[0],
                                ],
                                startDate: startDate,
                                endDate: endDate,
                                exchange:
                                  BuyerSellerState.BuyerSeller.filters[0],
                                product:
                                  BuyerSellerState.BuyerSeller.filters[1],

                                region: BuyerSellerState.BuyerSeller.filters[2],
                              });
                            } else {
                              fetchUtilityTrendData({
                                buyers: trendBuyer,
                                sellers: trendSeller.filter(
                                  (item) =>
                                    item !== e.map((item) => item.value)[0]
                                ),
                                startDate: startDate,
                                endDate: endDate,
                                exchange:
                                  BuyerSellerState.BuyerSeller.filters[0],
                                product:
                                  BuyerSellerState.BuyerSeller.filters[1],

                                region: BuyerSellerState.BuyerSeller.filters[2],
                              });
                              setTrendSeller(
                                trendSeller.filter(
                                  (item) =>
                                    item !== e.map((item) => item.value)[0]
                                )
                              );
                            }
                          }}
                          className="trendFilter"
                          options={BuyerSellerState.Trend.filters.seller_name
                            .filter((item) => !trendSeller.includes(item))
                            .map((item) => {
                              return {
                                value: item,
                                label: item,
                                isFixed: false,
                              };
                            })}
                          styles={searchStyle}
                        />
                        <div className="buyerSeller-legends"></div>
                        <div className="trends-chart">
                          <UtilizationTrendChart
                            data={BuyerSellerState.Trend.data.seller}
                            mcp={BuyerSellerState.Trend.data.mcp}
                            legends={trendSeller.map((item) => {
                              return {
                                dataKey: item,
                                name: item,
                                stroke:
                                  ExchangeColors[trendBuyer.indexOf(item)],
                              };
                            })}
                          />
                        </div>
                        <div className="buyerSeller-legends">
                          {trendSeller.map((item, index) => {
                            return (
                              <button
                                onClick={() => {
                                  setTrendSeller(
                                    trendSeller.filter(
                                      (item2) => item2 !== item
                                    )
                                  );
                                  fetchUtilityTrendData({
                                    buyers: trendBuyer,
                                    sellers: trendSeller.filter(
                                      (item2) => item2 !== item
                                    ),
                                    startDate: startDate,
                                    endDate: endDate,
                                    exchange:
                                      BuyerSellerState.BuyerSeller.filters[0],
                                    product:
                                      BuyerSellerState.BuyerSeller.filters[1],
                                    region:
                                      BuyerSellerState.BuyerSeller.filters[2],
                                  });
                                }}
                                key={index}
                                className="flex justify-between"
                              >
                                <div className="buyerSeller-Legend bar-legend">
                                  <p>
                                    <div
                                      className="dot"
                                      style={{
                                        backgroundColor:
                                          COLORS[
                                            index > COLORS.length - 1
                                              ? index - COLORS.length
                                              : index
                                          ],
                                      }}
                                    ></div>
                                    {item}
                                    <Cross />
                                  </p>
                                </div>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>{" "}
            </div>
          </div>
        ) : state.page == 4 ? (
          // Trend Analysis Page
          <div>
            <div className={""}>
              {activeUnitTab !== 4 && (
                <div className="exchange-chart-area">
                  <ComparisonChart
                    tooltip_key="dateIndex"
                    title="DAM"
                    data={
                      selectedComparisonExchange === 0
                        ? chartData.data.iex.dam
                        : selectedComparisonExchange === 1
                        ? chartData.data.pxil.dam
                        : chartData.data.hpx.dam
                    }
                  />

                  <ComparisonChart
                    tooltip_key="dateIndex"
                    title="GDAM"
                    data={
                      selectedComparisonExchange === 0
                        ? chartData.data.iex.gdam
                        : selectedComparisonExchange === 1
                        ? chartData.data.pxil.gdam
                        : chartData.data.hpx.gdam
                    }
                  />

                  <ComparisonChart
                    tooltip_key="dateIndex"
                    title="HPDAM"
                    data={
                      selectedComparisonExchange === 0
                        ? chartData.data.iex.hpdam
                        : selectedComparisonExchange === 1
                        ? chartData.data.pxil.hpdam
                        : chartData.data.hpx.hpdam
                    }
                  />

                  <ComparisonChart
                    tooltip_key="dateIndex"
                    title="RTM"
                    data={
                      selectedComparisonExchange === 0
                        ? chartData.data.iex.rtm
                        : selectedComparisonExchange === 1
                        ? chartData.data.pxil.rtm
                        : chartData.data.hpx.rtm
                    }
                  />

                  {(() => {
                    const datasets =
                      selectedComparisonExchange === 0
                        ? [
                            { key: "DAM", data: chartData.data.iex.dam },
                            { key: "GDAM", data: chartData.data.iex.gdam },
                            { key: "HPDAM", data: chartData.data.iex.hpdam },
                            { key: "RTM", data: chartData.data.iex.rtm },
                          ]
                        : selectedComparisonExchange === 1
                        ? [
                            { key: "DAM", data: chartData.data.pxil.dam },
                            { key: "GDAM", data: chartData.data.pxil.gdam },
                            { key: "HPDAM", data: chartData.data.pxil.hpdam },
                            { key: "RTM", data: chartData.data.pxil.rtm },
                          ]
                        : [
                            { key: "DAM", data: chartData.data.hpx.dam },
                            { key: "GDAM", data: chartData.data.hpx.gdam },
                            { key: "HPDAM", data: chartData.data.hpx.hpdam },
                            { key: "RTM", data: chartData.data.hpx.rtm },
                          ];

                    // Find the dataset with the largest length
                    const maxDataset = datasets.reduce((max, curr) =>
                      curr.data.length > max.data.length ? curr : max
                    );

                    return (
                      <div
                        className="m-4 w-full h-[5rem] brush-container"
                        style={{
                          marginRight: "20px",
                          overflow: "visible",
                        }}
                      >
                        <ExchangeChart
                          shownLegnends={[]}
                          brushStart={BrushStart.Start}
                          setShownLegends={function (
                            legends: string[]
                          ): void {}}
                          data={maxDataset.data}
                          title={maxDataset.key}
                          syncId="comparison"
                          height="20%"
                          width="100%"
                          showBrush={maxDataset.data.length > 1}
                          onlyBrush={true}
                        />
                      </div>
                    );
                  })()}
                </div>
              )}

              {activeUnitTab === 4 && (
                <div className="exchange-chart-area">
                  <WeightedAverageChart
                    // data={chartData.data.iex.dam}
                    data={
                      selectedComparisonExchange === 0
                        ? chartData.data.iex.dam
                        : selectedComparisonExchange === 1
                        ? chartData.data.pxil.dam
                        : chartData.data.hpx.dam
                    }
                    title="DAM"
                  />
                  <WeightedAverageChart
                    data={
                      selectedComparisonExchange === 0
                        ? chartData.data.iex.gdam
                        : selectedComparisonExchange === 1
                        ? chartData.data.pxil.gdam
                        : chartData.data.hpx.gdam
                    }
                    title="GDAM"
                  />

                  <WeightedAverageChart
                    data={
                      selectedComparisonExchange === 0
                        ? chartData.data.iex.hpdam
                        : selectedComparisonExchange === 1
                        ? chartData.data.pxil.hpdam
                        : chartData.data.hpx.hpdam
                    }
                    title="HPDAM"
                  />

                  <WeightedAverageChart
                    data={
                      selectedComparisonExchange === 0
                        ? chartData.data.iex.rtm
                        : selectedComparisonExchange === 1
                        ? chartData.data.pxil.rtm
                        : chartData.data.hpx.rtm
                    }
                    title="RTM"
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <EntityPage startDate={entityStartDate} endDate={entityEndDate} />
        )}
      </div>
    </div>
  );

  async function fetchSlotData({
    exchange,
    product,
    slot,
    date,
  }: {
    exchange: string;
    product: string;
    slot: string;
    date: string;
  }) {
    setExchangeLoading(true);

    // const res = await fetch("https://api-data.gna.energy/data/getTopBuySellData/", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({
    //     exchanges: [exchange],
    //     products: [product],
    //     time_slots: [slot],
    //     start_date: date,
    //     end_date: date,
    //   }),
    // });
    console.log("fetching data from exchange3", exchange, product, slot, date);

    const data = await fetchExchangeSlotData({
      exchange: exchange,
      product: product,
      slot: slot,
      date: date,
    });
    setExchangeLoading(false);
    setPopUpTitle(`${exchange} ${product}, ${slot} Time Slot of ${date} `);

    setPopupData(data);
    setPopUpVisible(true);
  }

  async function getExchangeData({
    start_date = startDate,
    end_date = endDate,
  }) {
    try {
      setExchangeLoading(true);
      let formatedStartDate = start_date
        .toLocaleDateString("en-GB")
        .split("/")
        .join("-");
      let formatedEndDate = end_date
        .toLocaleDateString("en-GB")
        .split("/")
        .join("-");

      await dispatch(
        fetchExchangeData({
          start_date: formatedStartDate,
          end_date: formatedEndDate,
        }) as any
      );
      setExchangeLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      swal("Please Try Again", "Error fetching Exchange Data. ", "warning");
    }
  }

  async function fetchRealTimeData() {
    console.log("fetching data");
    try {
      setRealTimeLoading(true);
      const response = await fetch(buildBaseUrl("data/getRealtimeIexPrices"), {
        headers: await buildHeaderTokens(),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data: any = await response.json();

      // const data = RealTimeData as any;
      const reChartTemp: RealTimeChartData[] = [];
      Object.keys(data).forEach((key: string, index) => {
        reChartTemp.push({
          title: key,
          data: [],
        });
        Object.keys(data[key]).forEach((key2: string, index2) => {
          Object.keys(data[key][key2]).forEach((key3: string, index3) => {
            if (reChartTemp[index].data[index3 as any] == undefined) {
              reChartTemp[index as any].data[index3 as any] = {
                timeslot: index3 + 1,
              };
            }
            try {
              reChartTemp[index].data[index3 as any][key2 as any] = parseFloat(
                data[key][key2][key3]
              );
            } catch (e) {
              console.log(data[key][key2]);
              console.log(e);
            }
          });
        });
      });

      Object.keys(data).forEach((key: string) => {});

      setRealTimeChartData(reChartTemp);
      setRealTimeLoading(false);

      console.log("data - ", reChartTemp);
    } catch (error) {
      console.error("Error fetching data:", error);
      swal("Please Try Again", "Error fetching Real Time Data. ", "warning");
    }
  }

  async function fetchBuyerVsSellerData({
    start_date,
    end_date,
    exchange,
    product,
    region,
  }: {
    start_date: Date;
    end_date: Date;
    exchange: BuyerSellerFilter;
    product: BuyerSellerFilter;
    region: BuyerSellerFilter;
  }) {
    try {
      setBuyerSellerLoading(true);
      // setIsBuyerLoading(true);
      const res = await buildFormDataRequest({
        endpoint: "data/getTopBuyerSeller/",
        body: {
          exchange: exchange.filters.map((item) => item.name),

          product: product?.filters.map((item) => item.name),
          region: region?.filters.map((item) => item.name),
          start_date: start_date
            .toLocaleDateString("en-GB")
            .split("/")
            .join("-"),
          end_date: end_date.toLocaleDateString("en-GB").split("/").join("-"),
        },
        method: "POST",
      });
      // setIsBuyerLoading(false);
      dispatch(
        setBuyerSellerData({
          buyer: res.buyer,
          seller: res.seller,
          region_buyer: res.region_buyer,
          region_seller: res.region_seller,
        })
      );
      setBuyerSellerLoading(false);
    } catch (e) {
      swal("Please Try Again", "Error fetching Buyer Seller Data. ", "warning");
      console.error("Error fetching data:", e);
    }
  }

  async function fetchUtilityTrendData({
    buyers,
    sellers,
    startDate,
    endDate,
    exchange,
    product,
    region,
  }: {
    buyers: string[];
    sellers: string[];
    startDate: Date;
    endDate: Date;
    exchange: BuyerSellerFilter;
    product: BuyerSellerFilter;
    region: BuyerSellerFilter;
  }) {
    try {
      setUtilityTrendLoading(true);
      const res = await buildFormDataRequest({
        endpoint: "data/getBuyerSellerTrendData/",
        body: {
          start_date: entityStartDate
            .toLocaleDateString("en-GB")
            .split("/")
            .join("-"),
          end_date: entityEndDate
            .toLocaleDateString("en-GB")
            .split("/")
            .join("-"),
          buyers: buyers,
          sellers: sellers,
          exchange: exchange.filters.map((item) => item.name),

          product: product?.filters.map((item) => item.name),
          region: region?.filters.map((item) => item.name),
        },
        method: "POST",
      });

      dispatch(setTrendData(res));
      setUtilityTrendLoading(false);
    } catch (e) {
      swal("Please Try Again", "Error fetching Trend Data. ", "warning");
      console.error("Error fetching data:", e);
    }
  }

  function getActivateFilter(isBuyerSeller?: boolean): boolean {
    if (state.page === 0) {
      return true;
    } else if (state.page === 1) {
      return true;
    }
    // else if (state.page === 3) {
    //   if (isBuyerSeller) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
    else {
      return false;
    }
  }

  function getLoading() {
    if (state.page === 0) {
      return exchangeLoading;
    } else if (state.page === 1) {
      return exchangeLoading;
    } else if (state.page === 2) {
      return realTimeLoading;
    } else if (state.page === 3) {
      if (buyerSellerPage === 0) {
        return buyerSellerLoading;
      } else if (buyerSellerPage === 1) {
        return utilityTrendLoading;
      }
    } else if (state.page === 4) {
      return ccomparisonLoading;
    } else {
      return false;
    }
  }
  function BuyerSellerPieChart({ data }: { data: BuyerSellerData[] }) {
    return (
      <div className="flex flex-col h-full w-full justify-center">
        <ResponsiveContainer>
          <PieChart data={data}>
            <Tooltip
              formatter={(value, name, props) => {
                return [
                  parseFloat(value.toString())
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " MWh",
                  name,
                ];
              }}
            />
            <Pie
              isAnimationActive={true}
              animationDuration={500}
              animationBegin={0}
              labelLine={false}
              data={data}
              dataKey="value"
              nameKey="name"
            >
              {data?.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={getColorList(COLORS.length)[index]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="flex flex-wrap justify-center gap-x-2 gap-y-2">
          {data?.map((item, index) => {
            return (
              <div>
                {LegendComponent(
                  {
                    dataKey: item.name,
                    type: ChartType.Bar,
                    name: item.name,
                    stroke: getColorList(COLORS.length)[index],
                  } as LegendKey,
                  index,
                  BuyerSellerState.BuyerSeller.filters[2].filters.map(
                    (filter) => {
                      return {
                        dataKey: filter.name,
                      };
                    }
                  ),

                  (legends: LegendKey) => {
                    dispatch(
                      AddBuyerSellerFilter({
                        index: 2,
                        filter: BuyerSellerFilters[2].filters[index],
                      })
                    );
                    const resultOptions = getResultFilterOptions(
                      data.map((item) => item.name),
                      BuyerSellerState.BuyerSeller.filters[2].filters.map(
                        (filter) => filter.name
                      ),
                      legends.dataKey
                    );
                    fetchBuyerVsSellerData({
                      start_date: entityStartDate,
                      end_date: entityEndDate,
                      exchange: BuyerSellerState.BuyerSeller.filters[0],
                      product: BuyerSellerState.BuyerSeller.filters[1],
                      region: {
                        id: 1,
                        name: "Region",
                        filters: resultOptions.map((option) => {
                          return {
                            id: 1,
                            name: option,
                          };
                        }),
                      },
                    });
                  }
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
  function ComparisonChart({
    data,
    title,
    tooltip_key,
  }: {
    data: any;
    title: string;
    tooltip_key?: string;
  }) {
    const uniqueDates = Array.from(
      new Set(data.map((item: { date: any }) => item.date))
    );

    // Add dateIndex to each data item
    const dataWithDateIndex = data.map((item: any) => ({
      ...item,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
    }));

    return (
      <div className="exchange-byExchange-chart">
        <div className="h-3"></div>
        <h2
          className="text-center text-l font-medium"
          style={{
            color: SecondaryColor,
          }}
        >
          {title}
        </h2>
        <ReMixChart
          // xLabel="Time (Hrs)"
          isTimeSlot={false}
          {...(tooltip_key && { tooltip_key })}
          yAxisWidth={activeUnitTab !== 0 ? 70 : 40}
          fontSize={12}
          brushStart={BrushStart.End}
          data={dataWithDateIndex}
          xTick={renderHourTick}
          xaxisHeight={30}
          secondXAxisHeight={10}
          dynamicMarginTop="mt-[-1.3rem]"
          xDataKey="time_slot"
          secondXDataKey="dateIndex"
          syncid="comparison"
          showBrush={true}
          brushHeight={0}
          yAxisLabel={unitTabs[activeUnitTab].unit}
          unit={unitTabs[activeUnitTab].unit}
          legends={chartData.legends.map((e) => {
            const activeUnit = unitTabs[activeUnitTab];
            return {
              dataKey: activeUnit.dataKey + "_" + e.dataKey,
              name: e.name ?? "No Name",
              stroke: e.stroke,
            };
          })}
        />
      </div>
    );
  }
  async function getComparisonExchangeData({ dates }: { dates: Date[] }) {
    try {
      if (dates.length === 0) {
        return;
      }

      // let datesToFetch = Dates that are not in rawcomparison by comparing with start data
      // let datesToFetch: Date[] = dates.filter(
      //   (date) =>
      //     !state.Exchange.comparisonRawData.find(
      //       (item) => item.date_range.start_date === date.toLocaleDateString("en-GB").split("/").join("-")
      //     )
      // );

      setComparisonLoading(true);

      // console.log("Dates to fetch", datesToFetch);
      let apidata = [];
      // if(datesToFetch.length<0){
      //    return;
      // }
      let compRawData = state.Exchange.comparisonRawData;
      // check if any date is removed from the date range by comparing with the raw data

      const res = await fetchExchangeComparisonData({
        dates: dates.map((e) => ({
          start_date: e
            .toLocaleDateString("en-GB")
            .split("/")
            .reverse()
            .join("-"),
          end_date: new Date(e.getFullYear(), e.getMonth() + 1, 0)
            .toLocaleDateString("en-GB")
            .split("/")
            .reverse()
            .join("-"),
        })),
      });
      apidata = await res;
      apidata = apidata.data;
      compRawData = apidata as any;
      const comparisonData: ComparisonData[] = [];
      let legends: LegendKey[] = [];
      dispatch(
        setComparisonRawData(
          state.Exchange.comparisonRawData.concat(apidata) as any
        )
      );

      for (let i = 0; i < compRawData.length; i++) {
        let data = {
          iex: {
            dam: FilterExchangeData(compRawData[i].data, {
              exchangeIndex: 0,
              exchangeProductIndex: 0,
            }),
            gdam: FilterExchangeData(compRawData[i].data, {
              exchangeIndex: 0,
              exchangeProductIndex: 1,
            }),
            hpdam: FilterExchangeData(compRawData[i].data, {
              exchangeIndex: 0,
              exchangeProductIndex: 2,
            }),
            rtm: FilterExchangeData(compRawData[i].data, {
              exchangeIndex: 0,
              exchangeProductIndex: 3,
            }),
          },
          hpx: {
            dam: FilterExchangeData(compRawData[i].data, {
              exchangeIndex: 2,
              exchangeProductIndex: 0,
            }),
            gdam: FilterExchangeData(compRawData[i].data, {
              exchangeIndex: 2,
              exchangeProductIndex: 1,
            }),
            hpdam: FilterExchangeData(compRawData[i].data, {
              exchangeIndex: 2,
              exchangeProductIndex: 2,
            }),
            rtm: FilterExchangeData(compRawData[i].data, {
              exchangeIndex: 2,
              exchangeProductIndex: 3,
            }),
          },
          pxil: {
            dam: FilterExchangeData(compRawData[i].data, {
              exchangeIndex: 1,
              exchangeProductIndex: 0,
            }),
            gdam: FilterExchangeData(compRawData[i].data, {
              exchangeIndex: 1,
              exchangeProductIndex: 1,
            }),
            hpdam: FilterExchangeData(compRawData[i].data, {
              exchangeIndex: 1,
              exchangeProductIndex: 2,
            }),
            rtm: FilterExchangeData(compRawData[i].data, {
              exchangeIndex: 1,
              exchangeProductIndex: 3,
            }),
          },
        };
        comparisonData.push({
          date: `${Months[dates[i].getMonth()]}-${dates[i].getFullYear()}`,
          data: data as any,
        });
        legends.push({
          dataKey: `${Months[dates[i].getMonth()]}_${dates[i].getFullYear()}`,
          name: `${Months[dates[i].getMonth()]}-${dates[i].getFullYear()}`,
          stroke: getColorList(dates.length)[i],
        });
      }
      console.log("Comparison Data", reformatData(comparisonData));
      setChartData({
        data: reformatData(comparisonData),
        legends: legends,
      });
      setComparisonLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      swal(
        "Something Went Wrong",
        "Error fetching Exchange Data. Please try again later",
        "warning"
      );
    }
  }

  function convertWeightedAverage({
    data,
    months,
  }: {
    data: {
      [key: string]: string | number | null;
    }[];
    months: string[];
  }): {
    month: string | number;
    value: number;
  }[] {
    const weightedAverage: {
      month: string | number;
      value: number;
    }[] = months.map((month) => ({
      month: month,
      value: 0,
    }));
    let totalCost: number[] = [];
    let volumes: number[] = [];

    months.forEach((month, index) => {
      const daysInMonth = getDaysInMonthFromString(month);
      const noOfSlots = 96 * daysInMonth;
      let totalCostMonth = 0;
      let volumeMonth = 0;
      data.forEach((item) => {
        const cost = parseFloat(
          item[`wt_mcp_rs_mwh_${month.replace(/-/g, "_")}`] as string
        );
        const volume = parseFloat(
          item[`mcv_mw_${month.replace(/-/g, "_")}`] as string
        );
        if (
          cost !== null &&
          volume !== null &&
          !isNaN(cost) &&
          !isNaN(volume)
        ) {
          totalCostMonth += cost * volume;
          volumeMonth += volume;
        }
      });
      totalCost.push(totalCostMonth);
      volumes.push(volumeMonth);
    });

    weightedAverage.forEach((item, index) => {
      console.log(
        item.month,
        "Total Cost - ",
        totalCost[index],
        "Total volume - ",
        volumes[index]
      );
      item.value = totalCost[index] / volumes[index];
    });

    console.log(weightedAverage);

    return weightedAverage;
  }
  function WeightedAverageChart({ data, title }: { data: any; title: string }) {
    return (
      <div className="exchange-byExchange-chart">
        <h2
          className="text-center text-md"
          style={{
            color: SecondaryColor,
          }}
        >
          {title}
        </h2>
        <ReBarChart
          showLegend={false}
          data={convertWeightedAverage({
            data: data,
            months: chartData.legends.map((e) => e.name) as string[],
          })}
          xDataKey="month"
          unit={COST_UNIT}
          yAxisLabel={COST_UNIT}
          legends={[
            {
              dataKey: "value",
              name: "Weighted Average",
              stroke: PrimaryColor,
            },
          ]}
        />
      </div>
    );
  }
}
